import { unstable_createMuiStrictModeTheme as createMuiTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

// Create a theme instance.
export const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#336183",
    },
    secondary: {
      main: "#E58F3D",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#fff",
    },
  },
});
